import {
  formatAmountWithLanguageCode,
  formatDatetime2,
} from "123tcs-common/utils/formatters";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../contexts/Language";
import SimulationTooltip from "../SimulationTooltip";

function Card({ card }) {
  // Contexts
  const { languageCode } = useLanguage();
  const { t: translate } = useTranslation();

  // Constants
  const leftSpanStyle = {
    color: "rgb(0, 0, 0)",
    fontFamily: "tahoma,geneva,sans-serif",
  };
  const rightSpanStyle = { fontFamily: "tahoma,geneva,sans-serif" };

  // Render
  return (
    <table border="0">
      <tbody>
        {/* CARD NUMBER */}
        <tr>
          <td width="150" height="30">
            <SimulationTooltip title="span strong">
              <span style={leftSpanStyle}>
                <strong>{translate("cardNumber")}</strong>
              </span>
            </SimulationTooltip>
          </td>

          <td>
            <SimulationTooltip title="span">
              <span style={rightSpanStyle}>{card.number}</span>
            </SimulationTooltip>
          </td>
        </tr>

        {/* PRODUCT NAME */}
        <tr>
          <td height="30">
            <SimulationTooltip title="span strong">
              <span style={leftSpanStyle}>
                <strong>{translate("productName")}</strong>
              </span>
            </SimulationTooltip>
          </td>

          <td>
            <SimulationTooltip title="span">
              <span style={rightSpanStyle}>{card.product.name}</span>
            </SimulationTooltip>
          </td>
        </tr>

        {/* STATUS */}
        <tr>
          <td height="30">
            <SimulationTooltip title="span strong">
              <span style={leftSpanStyle}>
                <strong>{translate("status")}</strong>
              </span>
            </SimulationTooltip>
          </td>

          <td>
            <SimulationTooltip title="span">
              <span style={rightSpanStyle}>{card.status}</span>
            </SimulationTooltip>
          </td>
        </tr>

        {/* BALANCE */}
        <tr>
          <td height="30">
            <SimulationTooltip title="span strong">
              <span style={leftSpanStyle}>
                <strong>{translate("balance")}</strong>
              </span>
            </SimulationTooltip>
          </td>

          <td>
            <SimulationTooltip title="span">
              <span style={rightSpanStyle}>
                {formatAmountWithLanguageCode(
                  card.balance,
                  card.currency,
                  languageCode,
                )}
              </span>
            </SimulationTooltip>
          </td>
        </tr>

        {/* EXPIRATION DATE */}
        <tr>
          <td height="30">
            <SimulationTooltip title="span strong">
              <span style={leftSpanStyle}>
                <strong>{translate("expirationDate")}</strong>
              </span>
            </SimulationTooltip>
          </td>

          <td>
            <SimulationTooltip title="span">
              <span style={rightSpanStyle}>
                {formatDatetime2(languageCode, card.expirationDate)}
              </span>
            </SimulationTooltip>
          </td>
        </tr>
      </tbody>
    </table>
  );
}

Card.propTypes = {
  card: PropTypes.shape({
    number: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    status: PropTypes.string.isRequired,
    balance: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    expirationDate: PropTypes.string.isRequired,
    product: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default Card;
